var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{staticClass:"group-type-selector",attrs:{"items":_vm.groupTypes,"attach":".group-type-selector","filled":_vm.filled,"readonly":_vm.readonly,"loading":_vm.loading,"return-object":""},model:{value:(_vm.selectedGroupType),callback:function ($$v) {_vm.selectedGroupType=$$v},expression:"selectedGroupType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }